import { LEARN_OPERATORS_PAGE_PATH, LEARN_PART_PATH_OPERATORS } from '../../../shared/constants';

export type SimulationTipType = {
  text: string;
  links: { [key: string]: string };
  audience: 'ALL' | 'CONSULTANT' | 'USER' | 'HIDDEN';
  priority: number;
};
export const simulationTips: SimulationTipType[] = [
  {
    text: 'simulationTipText-0',
    links: {
      'simulationTip-0-Link-0':
        'https://platform.worldquantbrain.com/sign-in?return_to=https%3A%2F%2Fsupport.worldquantbrain.com%2Fhc%2Fen-us%2Fcommunity%2Fposts%2F8677091679383--BRAIN-TIPS-Increasing-the-capacity-of-alphas',
    },
    audience: 'ALL',
    priority: 2,
  },
  {
    text: 'simulationTipText-1',
    links: {
      'simulationTip-1-Link-0': 'https://platform.worldquantbrain.com/data/data-sets?valueScore%3E=3',
      'simulationTip-1-Link-1': 'https://platform.worldquantbrain.com/data/data-sets?category=earnings',
      'simulationTip-1-Link-2': 'https://platform.worldquantbrain.com/data/data-sets?category=macro',
      'simulationTip-1-Link-3': 'https://platform.worldquantbrain.com/data/data-sets?category=insiders',
    },
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-2',
    links: {
      'simulationTip-2-Link-0': `https://platform.worldquantbrain.com/learn/${LEARN_PART_PATH_OPERATORS}/operators#transformational-operators`,
      'simulationTip-2-Link-1': `https://platform.worldquantbrain.com/learn/${LEARN_PART_PATH_OPERATORS}/operators#cross-sectional-operators`,
    },
    audience: 'ALL',
    priority: 2,
  },
  {
    text: 'simulationTipText-3',
    links: {
      'simulationTip-3-Link-0':
        'https://support.worldquantbrain.com/hc/en-us/community/posts/9121204386071--BRAIN-TIPS-How-does-neutralization-work-',
    },
    audience: 'ALL',
    priority: 3,
  },
  {
    text: 'simulationTipText-4',
    links: {
      'simulationTip-4-Link-0':
        'https://support.worldquantbrain.com/hc/en-us/community/posts/8833033953559--BRAIN-TIPS-5-ways-to-potentially-increase-returns-of-an-alpha',
    },
    audience: 'ALL',
    priority: 1,
  },
  {
    text: 'simulationTipText-5',
    links: {
      'simulationTip-5-Link-0':
        'https://support.worldquantbrain.com/hc/en-us/articles/19248385997719-Weight-Coverage-common-issues-and-advice',
    },
    audience: 'ALL',
    priority: 2,
  },
  {
    text: 'simulationTipText-6',
    links: {
      'simulationTip-6-Link-0':
        'https://support.worldquantbrain.com/hc/en-us/community/posts/9223578608663--BRAIN-TIPS-Seven-Tips-for-Creating-Delay-0-D0-Alphas',
    },
    audience: 'HIDDEN',
    priority: 2,
  },
  {
    text: 'simulationTipText-7',
    links: {
      'simulationTip-7-Link-0': 'https://platform.worldquantbrain.com/learn/documentation/superalpha/superalpha-overview',
      'simulationTip-7-Link-1': 'https://platform.worldquantbrain.com/learn/documentation/superalpha/helpful-tips',
    },
    audience: 'CONSULTANT',
    priority: 1,
  },
  {
    text: 'simulationTipText-8',
    links: {
      'simulationTip-8-Link-0': 'https://platform.worldquantbrain.com/learn/documentation/consultant-information/brain-api',
    },
    audience: 'CONSULTANT',
    priority: 4,
  },
  {
    text: 'simulationTipText-9',
    links: {
      'simulationTip-9-Link-0': 'https://support.worldquantbrain.com/hc/en-us/categories/11773945689495-Getting-Started-for-Users',
      'simulationTip-9-Link-1': 'https://platform.worldquantbrain.com/learn/courses/introduction-alphas',
    },
    audience: 'USER',
    priority: 1,
  },
  {
    text: 'simulationTipText-10',
    links: {
      'simulationTip-10-Link-0': 'https://platform.worldquantbrain.com/data/data-sets/socialmedia15',
      'simulationTip-10-Link-1': 'https://platform.worldquantbrain.com/learn/documentation/create-alphas/vector-datafields',
    },
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-11',
    links: {
      'simulationTip-11-Link-0': 'https://platform.worldquantbrain.com/learn/documentation/create-alphas/neut-users',
    },
    audience: 'CONSULTANT',
    priority: 2,
  },
  {
    text: 'simulationTipText-12',
    links: {
      'simulationTip-12-Link-0':
        'https://support.worldquantbrain.com/hc/en-us/articles/4902349883927-Click-here-for-a-list-of-terms-and-their-definitions#:~:text=B-,Backfill,-Replace%20missing%20values',
      'simulationTip-12-Link-1': `https://platform.worldquantbrain.com${LEARN_OPERATORS_PAGE_PATH}/operators#time-series-operators`,
      'simulationTip-12-Link-2': `https://platform.worldquantbrain.com${LEARN_OPERATORS_PAGE_PATH}/detailed-operator-descriptions#group_backfillx-group-d-std-40`,
      'simulationTip-12-Link-3': `https://platform.worldquantbrain.com${LEARN_OPERATORS_PAGE_PATH}/operators#group-operators`,
    },
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-13',
    links: {
      'simulationTip-13-Link-0': `https://platform.worldquantbrain.com${LEARN_OPERATORS_PAGE_PATH}/detailed-operator-descriptions#trade_when`,
    },
    audience: 'ALL',
    priority: 3,
  },
  {
    text: 'simulationTipText-14',
    links: {
      'simulationTip-14-Link-0': 'https://platform.worldquantbrain.com/data/data-sets?category=model',
    },
    audience: 'USER',
    priority: 1,
  },
  {
    text: 'simulationTipText-15',
    links: {
      'simulationTip-15-Link-0': 'https://platform.worldquantbrain.com/data/data-sets/model30',
      'simulationTip-15-Link-1': 'https://platform.worldquantbrain.com/data/data-sets/model17',
      'simulationTip-15-Link-2': 'https://platform.worldquantbrain.com/data/data-sets/pv1',
    },
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-16',
    links: {
      'simulationTip-16-Link-0': 'https://platform.worldquantbrain.com/data/data-sets/model10',
    },
    audience: 'CONSULTANT',
    priority: 1,
  },
  {
    text: 'simulationTipText-17',
    links: {},
    audience: 'ALL',
    priority: 2,
  },
  {
    text: 'simulationTipText-18',
    links: {},
    audience: 'USER',
    priority: 1,
  },
  {
    text: 'simulationTipText-19',
    links: {},
    audience: 'HIDDEN',
    priority: 2,
  },
  {
    text: 'simulationTipText-20',
    links: {
      'simulationTip-20-Link-0': 'https://platform.worldquantbrain.com/data/data-sets?category=socialmedia',
    },
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-21',
    links: {
      'simulationTip-21-Link-0': 'https://platform.worldquantbrain.com/data/data-sets/news18',
    },
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-22',
    links: {
      'simulationTip-22-Link-0': 'https://platform.worldquantbrain.com/data/data-sets/model165',
    },
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-23',
    links: {
      'simulationTip-23-Link-0': 'https://platform.worldquantbrain.com/data/data-sets?category=analyst',
    },
    audience: 'CONSULTANT',
    priority: 1,
  },
  {
    text: 'simulationTipText-24',
    links: {
      'simulationTip-24-Link-0': 'https://platform.worldquantbrain.com/data/data-sets/option9',
    },
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-25',
    links: {},
    audience: 'CONSULTANT',
    priority: 1,
  },
  {
    text: 'simulationTipText-26',
    links: {},
    audience: 'USER',
    priority: 1,
  },
  {
    text: 'simulationTipText-27',
    links: {},
    audience: 'ALL',
    priority: 2,
  },
  {
    text: 'simulationTipText-28',
    links: {},
    audience: 'ALL',
    priority: 4,
  },
  {
    text: 'simulationTipText-29',
    links: {
      'simulationTip-29-Link-0':
        'https://support.worldquantbrain.com/hc/en-us/community/topics/12997688420247-Research-Papers-for-Consultants',
    },
    audience: 'CONSULTANT',
    priority: 3,
  },
  {
    text: 'simulationTipText-30',
    links: {
      'simulationTip-30-Link-0': 'https://platform.worldquantbrain.com/learn/documentation/create-alphas/19-alpha-examples',
    },
    audience: 'USER',
    priority: 4,
  },
  {
    text: 'simulationTipText-31',
    links: {},
    audience: 'ALL',
    priority: 3,
  },
  {
    text: 'simulationTipText-32',
    links: {},
    audience: 'ALL',
    priority: 2,
  },
  {
    text: 'simulationTipText-33',
    links: {},
    audience: 'ALL',
    priority: 2,
  },
  {
    text: 'simulationTipText-34',
    links: {
      'simulationTip-34-Link-0': `https://platform.worldquantbrain.com${LEARN_OPERATORS_PAGE_PATH}/detailed-operator-descriptions`,
    },
    audience: 'ALL',
    priority: 3,
  },
  {
    text: 'simulationTipText-35',
    links: {},
    audience: 'HIDDEN',
    priority: 1,
  },
  {
    text: 'simulationTipText-36',
    links: {},
    audience: 'ALL',
    priority: 2,
  },
  {
    text: 'simulationTipText-37',
    links: {},
    audience: 'CONSULTANT',
    priority: 2,
  },
  {
    text: 'simulationTipText-38',
    links: {},
    audience: 'CONSULTANT',
    priority: 2,
  },
  {
    text: 'simulationTipText-39',
    links: {
      'simulationTip-39-Link-0': `https://platform.worldquantbrain.com${LEARN_OPERATORS_PAGE_PATH}/detailed-operator-descriptions#bucket`,
    },
    audience: 'ALL',
    priority: 3,
  },
  {
    text: 'simulationTipText-40',
    links: {
      'simulationTip-40-Link-0': `https://platform.worldquantbrain.com${LEARN_OPERATORS_PAGE_PATH}/detailed-operator-descriptions#vector_neutxy`,
    },
    audience: 'HIDDEN',
    priority: 3,
  },
  {
    text: 'simulationTipText-41',
    links: {
      'simulationTip-41-Link-0': 'https://platform.worldquantbrain.com/data/data-sets/analyst7',
    },
    audience: 'CONSULTANT',
    priority: 1,
  },
  {
    text: 'simulationTipText-42',
    links: {
      'simulationTip-42-Link-0': 'https://platform.worldquantbrain.com/data/data-sets/fundamental6',
    },
    audience: 'CONSULTANT',
    priority: 1,
  },
  {
    text: 'simulationTipText-43',
    links: {
      'simulationTip-43-Link-0':
        'https://platform.worldquantbrain.com/data/data-sets?search=other%20employee%20data&subcategory=other-employee-data',
    },
    audience: 'CONSULTANT',
    priority: 1,
  },
];

export const consultantSimulationTips = simulationTips.filter(tip => tip.audience === 'ALL' || tip.audience === 'CONSULTANT');

export const regularUserSimulationTips = simulationTips.filter(tip => tip.audience === 'ALL' || tip.audience === 'USER');
